import { StationUnit } from "@/models/stationUnit.js"




export class ModemUnit extends StationUnit {
		// Passport keys in DB
	static get passportKeys() {
		return Object.freeze({
			self: 'modem_unit',
			unitVersion: 'unit_version',
			unitPort: 'unit_port',
			unitModbusAddr: 'unit_modbus_addr',

			allowedGridMode1: 'allowed_grid_mode_1',
			allowedGridMode2: 'allowed_grid_mode_2',
			allowedServers1: 'allowed_servers_1',
			allowedServers2: 'allowed_servers_2',
			selfServerPort1: 'self_server_port_1',
			server1Port1: 'server_1_port_1',
			server2Port1: 'server_2_port_1',
			selfServerPort2: 'self_server_port_2',
			server1Port2: 'server_1_port_2',
			server2Port2: 'server_2_port_2',
			forwardingAddr1: 'forwarding_addr_1',
			forwardingAddr2: 'forwarding_addr_2',
			ip_1_octet_1: 'ip_1_octet_1',
			ip_2_octet_1: 'ip_2_octet_1',
			ip_3_octet_1: 'ip_3_octet_1',
			ip_4_octet_1: 'ip_4_octet_1',
			serverPort1: 'server_port_1',
			ip_1_octet_2: 'ip_1_octet_2',
			ip_2_octet_2: 'ip_2_octet_2',
			ip_3_octet_2: 'ip_3_octet_2',
			ip_4_octet_2: 'ip_4_octet_2',
			serverPort2: 'server_port_2',
			timeout1: 'timeout_1',
			timeout2: 'timeout_2',
			speed1: 'speed_1',
			speed2: 'speed_2',
			bitCount1: 'bit_count_1',
			bitCount2: 'bit_count_2',
			stopBit1: 'stop_bit_1',
			stopBit2: 'stop_bit_2',
			parity1: 'parity_1',
			parity2: 'parity_2',
			convertingRtu1: 'converting_rtu_1',
			convertingRtu2: 'converting_rtu_2',
			apn1: 'apn_1',
			apn2: 'apn_2',

			relatedRpc: 'related_rpc',
		})
	}

	// Metric keys in DB
	static get metricKeys() {
		const settingsKeys = { ...ModemUnit.passportKeys }
		delete settingsKeys.self
		delete settingsKeys.unitVersion
		delete settingsKeys.unitPort
		delete settingsKeys.unitModbusAddr

		return Object.freeze(
			Object.assign(
				{
					isConnect: 'is_connection',
					lastConnection: 'last_connection',
					unitName: 'unit_name',
					assemblyDate: 'assembly_date',
					sigLevel_1: 'sig_level_1',
					sigLevel_2: 'sig_level_2',
					gridMode_1: 'grid_mode_1',
					gridMode_2: 'grid_mode_2',
				},
				settingsKeys,
			)
		)
	}

	// Unit versions
	static get versions() {
		return Object.freeze({
			autodetect: 'autodetect',
			'Мod4Gx101': 'Mod4Gx1-01.2',
			'Мod4Gx203': 'Mod4Gx2-03.1',
			'Mod4Gx204': 'Mod4Gx2-04.0',
			'Mod4Gx2041': 'Mod4Gx2-04.1',
			unknown: 'unknown',
		})
	}

	// Unit version names
	static get versionNames() {
		return Object.freeze({
			[ModemUnit.versions.autodetect]: 'Автовизначення',
			[ModemUnit.versions.Мod4Gx101]: 'Одномодульний MGTW-102',
			[ModemUnit.versions.Мod4Gx203]: 'Двухмодульний MGTW-202 версії 3',
			[ModemUnit.versions.Mod4Gx204]: 'Двухмодульний MGTW-202 версії 4',
			[ModemUnit.versions.Mod4Gx2041]: 'Двухмодульний MGTW-202 версії 4.120',
			[ModemUnit.versions.unknown]: 'Відсутній (невизначений)',		
		})
	}

	// Unit setting names for interface
	static get settingNames() {
		return Object.freeze({
			[ModemUnit.passportKeys.unitVersion]: 'Версія модема',
			[ModemUnit.passportKeys.unitPort]: 'Порт модема',
			[ModemUnit.passportKeys.unitModbusAddr]: 'ModBus адреса модема',

			[ModemUnit.passportKeys.allowedGridMode1]: 'Дозволені типи мережі',
			[ModemUnit.passportKeys.allowedGridMode2]: 'Дозволені типи мережі',
			[ModemUnit.passportKeys.allowedServers1]: 'Дозволені сервери',
			[ModemUnit.passportKeys.allowedServers2]: 'Дозволені сервери',
			[ModemUnit.passportKeys.selfServerPort1]: 'Порт сервера 0 (сервер налаштувань модема)',
			[ModemUnit.passportKeys.server1Port1]: 'Порт сервера 1 (перший RS485)',
			[ModemUnit.passportKeys.server2Port1]: 'Порт сервера 2 (другий RS485)',
			[ModemUnit.passportKeys.selfServerPort2]: 'Порт сервера 0 (сервер налаштувань модема)',
			[ModemUnit.passportKeys.server1Port2]: 'Порт сервера 1 (перший RS485)',
			[ModemUnit.passportKeys.server2Port2]: 'Порт сервера 2 (другий RS485)',
			[ModemUnit.passportKeys.forwardingAddr1]: 'Адреса даних що прокидуються з порта 1',
			[ModemUnit.passportKeys.forwardingAddr2]: 'Адреса даних що прокидуються з порта 2',
			ip: 'IP адреса центрального сервера',
			[ModemUnit.passportKeys.ip_1_octet_1]: 'IP адреса центрального сервера, октет 1',
			[ModemUnit.passportKeys.ip_2_octet_1]: 'IP адреса центрального сервера, октет 2',
			[ModemUnit.passportKeys.ip_3_octet_1]: 'IP адреса центрального сервера, октет 3',
			[ModemUnit.passportKeys.ip_4_octet_1]: 'IP адреса центрального сервера, октет 4',
			[ModemUnit.passportKeys.serverPort1]: 'Порт центрального сервера модуля №1',
			[ModemUnit.passportKeys.ip_1_octet_2]: 'IP адреса центрального сервера, октет 1',
			[ModemUnit.passportKeys.ip_2_octet_2]: 'IP адреса центрального сервера, октет 2',
			[ModemUnit.passportKeys.ip_3_octet_2]: 'IP адреса центрального сервера, октет 3',
			[ModemUnit.passportKeys.ip_4_octet_2]: 'IP адреса центрального сервера, октет 4',
			[ModemUnit.passportKeys.serverPort2]: 'Порт центрального сервера модуля №2',
			[ModemUnit.passportKeys.timeout1]: 'Таймаут центрального сервера модуля №1, c',
			[ModemUnit.passportKeys.timeout2]: 'Таймаут центрального сервера модуля №2, c',
			[ModemUnit.passportKeys.speed1]: 'Швидкість RS485 порта №1',
			[ModemUnit.passportKeys.speed2]: 'Швидкість RS485 порта №2',
			[ModemUnit.passportKeys.bitCount1]: 'Біти даних RS485 порта №1',
			[ModemUnit.passportKeys.bitCount2]: 'Біти даних RS485 порта №2',
			[ModemUnit.passportKeys.stopBit1]: 'Стоп біти RS485 порта №1',
			[ModemUnit.passportKeys.stopBit2]: 'Стоп біти RS485 порта №2',
			[ModemUnit.passportKeys.parity1]: 'Парність RS485 порта №1',
			[ModemUnit.passportKeys.parity2]: 'Парність RS485 порта №2',
			[ModemUnit.passportKeys.convertingRtu1]: 'Конвертування ModBusTCP <-> ModBusRTU порта №1',
			[ModemUnit.passportKeys.convertingRtu2]: 'Конвертування ModBusTCP <-> ModBusRTU порта №2',
			[ModemUnit.passportKeys.apn1]: 'APN модуля №1',
			[ModemUnit.passportKeys.apn2]: 'APN модуля №2',
		})
	}

	static get allowedGridModeNames() {
		return [
			{code: 0, title: 'Автоматичний'},
			{code: 1, title: 'GSM (2G)'},
			{code: 2, title: 'WCDMA (3G)'},
			{code: 3, title: 'LTE (4G)'},
			{code: 4, title: 'GSM + WCDMA (2G+3G)'},
			{code: 5, title: 'GSM + LTE (2G+4G)'},
			{code: 6, title: 'WCDMA + LTE (3G+4G)'},
		]
	}

	static get serverNames() {
		return [
			{code: 0, title: 'Тільки сервер 0'},
			{code: 1, title: 'Сервери 0 та 1'},
			{code: 2, title: 'Сервери 0 та 2'},
			{code: 3, title: 'Сервери 0, 1 та 2'},
		]
	}

	static get curentGridModeNames() {
		return [
			{code: 0, title: 'Відсутня'},
			{code: 1, title: '2G'},
			{code: 2, title: '3G'},
			{code: 3, title: '4G'},
		]
	}

	static get portSpeedModeNames() {
		return [
			{code: 0, title: '4800'},
			{code: 1, title: '9600'},
			{code: 2, title: '14400'},
			{code: 3, title: '19200'},
			{code: 4, title: '38400'},
			{code: 5, title: '57600'},
			{code: 6, title: '115200'},
		]
	}

	static get dataBitsCountNames() {
		return [
			{code: 0, title: '7 біт'},
			{code: 1, title: '8 біт'},
		]
	}

	static get stopBitsCountNames() {
		return [
			{code: 0, title: '1 біт'},
			{code: 1, title: '2 біта'},
		]
	}

	static get parityNames() {
		return [
			{code: 0, title: 'вимкнено'},
			{code: 1, title: 'парність'},
			{code: 2, title: 'непарність'},
		]
	}

	static get rtuModeNames() {
		return [
			{code: 0, title: 'вимкнено'},
			{code: 1, title: 'ввімкнено'},
		]
	}

	get passport() {
		return this._passport.get(ModemUnit.passportKeys.self)
	}

	// Return true if unit version is not unknown
	get isPresent() {
		if (!this.passport 
			|| !this.passport[ModemUnit.passportKeys.unitVersion]
			|| this.passport[ModemUnit.passportKeys.unitVersion] == ModemUnit.versions.unknown
		) {
			return false
		} else {
			return true
		}
	}

	// Return unit connection metric
	get isConnect() {
		// If not present
		if (!this.isPresent) {
			return false
		}

		if (this.metrics.has(ModemUnit.metricKeys.isConnect)) {
			return this.metrics.get(ModemUnit.metricKeys.isConnect).value
		} else {
			return false
		}
	}

	get connectionText() {
		return ModemUnit.connectionText(this.isConnect)
	}

	get connectionQuality() {
		const sigLevel_1 = this.getMetric(ModemUnit.metricKeys.sigLevel_1)?.value
		const sigLevel_2 = this.getMetric(ModemUnit.metricKeys.sigLevel_2)?.value

		return ModemUnit.makeConnectionQualityInPercent(sigLevel_1, sigLevel_2)        
	}

	static makeConnectionQualityInPercent(sigLevel_1, sigLevel_2) {
		let sigLevel

		if (sigLevel_1 == undefined && sigLevel_2 == undefined)
			return undefined
		else if (sigLevel_1 == undefined && sigLevel_2 !== undefined)
			sigLevel = sigLevel_2
		else if (sigLevel_1 !== undefined && sigLevel_2 == undefined)
			sigLevel = sigLevel_1
		else if (sigLevel_1 !== undefined && sigLevel_2 !== undefined)
			sigLevel = Math.max(sigLevel_1, sigLevel_2)
		else
			return undefined

		if (sigLevel == undefined || isNaN(sigLevel)) {
			return undefined
		}

		if (sigLevel == 99) {
			return undefined
		}
		
		return sigLevel / (31.0 / 100.0)
	}

	get modulesCount() {
		if (String(ModemUnit.versions['Мod4Gx101']).localeCompare(String(this.getMetric(ModemUnit.metricKeys.unitName)?.value)) == 0) {
			return 1
		} else {
			return 2
		}
	}
}